export const splitList = (s) => (s || "").split(/[,\n]/).map((x) => x.trim()).filter(Boolean);
export const joinList = (a) => (a || []).join(", ");

export const STATUS_META = {
  pending: { label: "Σε αναμονή", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  approved: { label: "Εγκρίθηκε", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Απορρίφθηκε", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const PROJECT_STATUS = {
  draft: "Πρόχειρο",
  running: "Αναζήτηση...",
  enriching: "Εμπλουτισμός...",
  verifying: "Έλεγχος sites...",
  ready: "Έτοιμο",
  error: "Σφάλμα",
};

export const isBusy = (s) => ["running", "enriching", "verifying"].includes(s);

export const VERIFY_META = {
  yes: { label: "✓ Επιβεβαιώθηκε", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  no: { label: "✗ Δεν ταιριάζει", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  unclear: { label: "? Ασαφές", cls: "bg-slate-50 text-slate-600 border-slate-200" },
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && d) return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x === "string" ? x : x?.msg || JSON.stringify(x))).join(" · ");
  if (d && typeof d === "object") return d.message || JSON.stringify(d);
  if (e?.code === "ECONNABORTED") return "Η σύνδεση άργησε πολύ — δοκιμάστε ξανά";
  if (e?.response && !e.response.data) return `Σφάλμα διακομιστή (${e.response.status})`;
  return typeof e?.message === "string" && e.message ? e.message : "Σφάλμα";
};
